// libs
import React from 'react';
import { useNavigate } from 'react-router-dom';
// dls
import { Button } from '@swiggy-private/dls-web-core/dist/components/Button';
// constants
import Routes from '@/constants/Routes';
// styles
import styles from './CreateCampaignButton.module.scss';
// components
import Tooltip from '@/components/Tooltip';
// stores
import useConfigStore from '@/stores/Configs';
const CreateCampaignButton = () => {
    const { campaignOpDisabled, campaignOpDisabledCallout } = useConfigStore((state) => ({
        campaignOpDisabled: state.campaignOpDisabled,
        campaignOpDisabledCallout: state.campaignOpDisabledCallout,
    }));
    const navigate = useNavigate();
    const handleCreateCampaignClick = () => {
        navigate(Routes.INSTAMART.CAMPAIGN_CREATE, {
            preventScrollReset: true,
        });
    };
    const buttonNode = (React.createElement(Button, { variant: "primary", buttonSize: "small", onClick: handleCreateCampaignClick, disabled: campaignOpDisabled }, "Create Campaign"));
    return (React.createElement("div", { className: styles.container }, campaignOpDisabled ? (React.createElement(Tooltip, { content: campaignOpDisabledCallout, inline: false }, buttonNode)) : (buttonNode)));
};
export default CreateCampaignButton;
